import { getMainCoverage, getPolicyTotalPremium, parseLocalDate } from './calculations.js'

const hasText = (value) => Boolean(String(value || '').trim())
const issue = (key, label, severity = 'warning') => ({ key, label, severity })

export const getPolicyDataIssues = (policy = {}) => {
  const issues = []

  if (!hasText(policy.company)) issues.push(issue('company', '保险公司', 'danger'))
  if (!hasText(policy.productName)) issues.push(issue('productName', '产品名称', 'danger'))
  if (!hasText(policy.applicant)) issues.push(issue('applicant', '投保人', 'danger'))
  if (!hasText(policy.insuredPerson)) issues.push(issue('insuredPerson', '被保人', 'danger'))
  if (!parseLocalDate(policy.effectiveDate)) issues.push(issue('effectiveDate', '生效日期', 'danger'))
  if (Number(policy.paymentTerm) < 1) issues.push(issue('paymentTerm', '缴费期', 'danger'))

  if (getPolicyTotalPremium(policy) <= 0) issues.push(issue('annualPremium', '保费'))
  if (getMainCoverage(policy) <= 0) issues.push(issue('mainCoverage', '主险保额'))

  return issues
}
